<script setup lang="ts">
import SaveToFolderModal from '@/components/SaveToFolderModal.vue'
import { CONTENT_TYPES } from '@/util/access_visibility'
import { SubjectSummary } from '@/presentlevels/presentlevels_types.ts'
import { computed, ref } from 'vue'
import { postSubjectSummary } from '@/presentlevels/api_v2.ts'
import { usePresentLevelsStore } from '@/presentlevels/presentlevels.store.ts'
import { useUserStore } from '@/authentication/user.store'

const presentlevelsStore = usePresentLevelsStore()

const props = defineProps({
  contentUuid: {
    type: String,
    required: true
  },
  preserveSession: {
    type: Boolean,
    default: false
  },
  postCopyNavigate: {
    type: Boolean,
    default: true
  }
})

const summary = computed(() => {
  return presentlevelsStore.subjectSummaries.find(s => s.uuid === props.contentUuid)
})

const summaryCopyUUID = ref('')

const preSaveFunction = async () => {
  if (!summary.value) {
    return
  }
  const duplicateSummary = {
    ...summary.value,
    creator_uuid: useUserStore().userId,
    uuid: ''
  }
  if (!props.preserveSession) {
    duplicateSummary.pl_session_uuid = ''
  }


  const summaryCopy: SubjectSummary = await postSubjectSummary(duplicateSummary)
  summaryCopyUUID.value = summaryCopy.uuid
}
</script>

<template>
  <SaveToFolderModal
    :content-type="CONTENT_TYPES.PRESENTLEVEL_STUDENT_SUMMARY"
    content-type-label="Student Summary"
    :content-uuid="summaryCopyUUID"
    custom-header="Copy Student Summary to Another Folder"
    :pre-save-function="preSaveFunction"
    :post-save-navigate="postCopyNavigate"
    @update:visible="(val) => $emit('visible', val)"
    @save="(folder) => $emit('save', folder)"
  />
</template>

<style scoped>

</style>